import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { toast } from "sonner";
import crm, { apiErr } from "../crmApi";
import { Loader } from "../CrmApp";
import { inr, fileSrc, useWmPerms } from "./WebsiteApp";

export default function WmFeatured() {
  const perms = useWmPerms();
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState("");
  const load = useCallback(() => crm.wm.list({ status: "published" }).then((d) => setItems(d.items)).catch((e) => toast.error(apiErr(e))), []);
  useEffect(() => { load(); }, [load]);
  const toggle = async (p) => {
    setBusy(p.id);
    try { await crm.wm.featured(p.id, !p.featured); toast.success(p.featured ? "Removed from featured — website updated" : "Now featured on the website"); load(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(""); }
  };
  if (!items) return <Loader />;
  const featured = items.filter((p) => p.featured);
  return (
    <div>
      <p className="text-sm text-pbs-grey mb-3">Featured listings appear first in the website's featured sections. Changes apply to the live site immediately{!perms.can_publish && " — you need publishing permission to change them"}.</p>
      <p className="text-xs font-bold text-pbs-plum mb-2" data-testid="wm-featured-count">{featured.length} featured of {items.length} live listings</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {[...featured, ...items.filter((p) => !p.featured)].map((p) => (
          <div key={p.id} className={`crm-card overflow-hidden ${p.featured ? "ring-2 ring-pbs-gold" : ""}`} data-testid={`wm-feat-card-${p.slug}`}>
            <div className="aspect-[16/9] bg-pbs-bg">{p.image && <img src={fileSrc(p.image)} alt="" className="w-full h-full object-cover" />}</div>
            <div className="p-3 flex items-center justify-between gap-2">
              <div className="min-w-0"><Link to={`/crm/website/edit/${p.id}`} className="font-semibold text-sm text-pbs-dark truncate block hover:text-pbs-purple">{p.name}</Link><p className="text-xs text-pbs-grey">{p.city} · {inr(p.price)}</p></div>
              <button disabled={!perms.can_publish || busy === p.id} onClick={() => toggle(p)} data-testid={`wm-feat-toggle-${p.slug}`} title={p.featured ? "Unfeature" : "Feature"}
                className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center border transition-colors disabled:opacity-40 ${p.featured ? "bg-pbs-gold border-pbs-gold text-pbs-plum" : "border-pbs-line text-pbs-grey hover:text-pbs-gold"}`}>
                <Star size={16} fill={p.featured ? "currentColor" : "none"} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
